import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule, LockKeyhole } from 'lucide-angular';

@Component({
  selector: 'app-unauthorized', standalone: true, imports: [RouterLink, LucideAngularModule],
  template: `<section class="empty-state standalone unauthorized"><div class="lock-icon"><lucide-angular [img]="LockKeyhole" /></div><span>403</span><h1>你沒有這個頁面的權限</h1><p>管理者白名單僅開放 ROOT 角色使用。你仍可查詢活動與刪除紀錄。</p><a class="button primary" routerLink="/games">返回活動管理</a></section>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedComponent { readonly LockKeyhole = LockKeyhole; }
